<template lang='pug' src='./bothWizard.pug' />

<script>
import menuResidential from '@/components/complianceWizard/residentialWizards/menuResidential.vue'
import menuResidentialVariation from '@/components/complianceWizard/residentialWizards/menuResidentialVaration.vue'

import commercialWizards from '@/components/complianceWizard/commercialWizards/MenuComercial.vue'
import newBuildingsCommercialComponent from '@/components/complianceWizard/commercialWizards/newBuilding.vue'

import coveredProcess from '@/components/complianceWizard/pop/coveredProcess.vue'

import newBuildingsComponent from '@/components/complianceWizard/residentialWizards/newBuildings.vue'

import existingPlusAlteration from '@/components/complianceWizard/residentialWizards/existingPlusAlteration.vue'
import popUpUpload from '@/commonSite/uploadFiles'
import LocalStorageService from '@/commonSite/StorageService.js'

export default {
	name: 'both-wizard',
	components: {
		menuResidential,
		commercialWizards,
		coveredProcess,
		menuResidentialVariation,
		popUpUpload,
		newBuildingsComponent,
		newBuildingsCommercialComponent,
		existingPlusAlteration
	},
	data: function () {
		return {
			guideMessages: ['Step 1: Specify the Occupancy Classification / Building Type', 'Step 2: What does your project consist of?',
				'Step 3: Now select the type of work to be performed to know the cost'],
			titlemessages: 'Step 1: Specify the Occupancy Classification / Building Type',
			selectedFirstRadiosGroup: 'first',
			selectedSecondRadiosGroup: 'first',
			activeRadio: null,
			checked: false,
			showCollapseA: false,
			showCollapseB: false,
			wichPopup: '',
			is_desktop: true
		}
	},
	created: function () {
		this.getAccordionsValue()
	},
	mounted: function () {
		this.isDesktop()
		window.addEventListener('resize', this.isDesktop)
	},
	methods: {
		isDesktop: function () {
			let widthPage = document.documentElement.clientWidth
			if (widthPage >= 993) {
				this.is_desktop = true
			} else {
				this.is_desktop = false
			}
		},
		getAccordionsValue () {
			let localStorage = new LocalStorageService()
			this.showCollapseA = localStorage.findItem('showCollapseA', true)
			this.showCollapseB = localStorage.findItem('showCollapseB', true)
			this.selectedFirstRadiosGroup = localStorage.findItem('selectedFirstRadiosGroup', true)
			this.selectedSecondRadiosGroup = localStorage.findItem('selectedSecondRadiosGroup', true)
		},
		setAccordionState () {
			let localStorage = new LocalStorageService()
			localStorage.setItem('showCollapseA', this.showCollapseA, true)
			localStorage.setItem('showCollapseB', this.showCollapseB, true)
		},
		whereAreWeFirst: function (value) {
			// This method detect if select correct option return true
			if (this.selectedFirstRadiosGroup === value) {
				this.titlemessages = this.guideMessages[2]
				return true
			}
			localStorage.setItem('selectedFirstRadiosGroup', this.selectedFirstRadiosGroup, true)
		},
		whereAreWeSecond: function (value) {
			// This method detect if select correct option return true
			if (this.selectedSecondRadiosGroup === value) {
				this.titlemessages = this.guideMessages[2]
				return true
			}
			localStorage.setItem('selectedSecondRadiosGroup', this.selectedSecondRadiosGroup, true)
		},
		changeTitleAndOpenAccordeon: function (value) {
			if (value === 1) {
				this.behaveA()
			} else {
				this.behaveB()
			}
			this.selectedFirstRadiosGroup = false
			this.selectedSecondRadiosGroup = false

			if (this.showCollapseA || this.showCollapseB) {
				this.titlemessages = this.guideMessages[1]
			} else {
				this.titlemessages = this.guideMessages[0]
			}
			this.setAccordionState()
		},
		behaveA: function () {
			this.showCollapseA = !this.showCollapseA
			this.showCollapseB = false
		},
		behaveB: function () {
			this.showCollapseB = !this.showCollapseB
			this.showCollapseA = false
		},
		showModal (value) {
			this.wichPopup = value
			this.$refs.myModalRef.show()
			console.log('se llama el show')
		},
		hideModal () {
			this.$refs.myModalRef.hide()
		}
	}
}
</script>

<style lang="less" >
</style>



// WEBPACK FOOTER //
// src/components/complianceWizard/bothWizard.vue